import { render, staticRenderFns } from "./time-widget.vue?vue&type=template&id=122f8e7b&scoped=true"
import script from "./time-widget.vue?vue&type=script&lang=js"
export * from "./time-widget.vue?vue&type=script&lang=js"
import style0 from "./time-widget.vue?vue&type=style&index=0&id=122f8e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f8e7b",
  null
  
)

export default component.exports